import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';
import { CallStateEnum } from '@models/call-state.model.ts';
import { TableState } from '@store/table-store/table.model.ts';
import { SelectOption } from '@models/global.model.ts';

export type HandleClose = () => void;

export interface ServicesActionParams {
  data?: any;
  id?: number;
  state?: TableState;
  handleClose?: HandleClose;
}

export interface ServicesState extends CallStateMethods {
  callState: CallStateEnum;
  departmentUnit: SelectOption[];
  getDepartmentUnit: () => void;
  createService: (params: ServicesActionParams) => Promise<any>;
  editService: (params: ServicesActionParams) => void;
  deleteService: (params: ServicesActionParams) => void;
  togglePublish: (params: ServicesActionParams) => void;
}

interface ServicesStateMethods extends CallStateMethodNames {
  createService: 'createService';
  editService: 'editService';
  deleteService: 'deleteService';
  getDepartmentUnit: 'getDepartmentUnit';
  togglePublish: 'togglePublish';
}

export const SERVICES_INITIAL_STATE: Omit<
  ServicesState,
  keyof ServicesStateMethods
> = {
  departmentUnit: [],
  callState: CallStateEnum.Init
};
